import { httpCreate } from './http';
import { createNamespacedHelpers } from 'vuex';

const http = httpCreate('/srv/intro');

export const intro = {
	//获取简介详情
	getIntroDetail(id) {
		return http.get(`/${id}`);
	},
	//添加模板
	addMould(id, data) {
		return http.post(`/saveModel/${id}`, data);
	},
	//修改模板
	changeMould(id, data) {
		return http.post(`/updateModel/${id}`, data);
	},
	//删除模板
	deleteMould(id) {
		return http.delete(`/deleteModel/${id}`);
	},
	//添加主办方/嘉宾
	addGuest(id, data) {
		return http.post(`/saveDetail/${id}`, data);
	},
	//修改主办方/嘉宾
	changeGuest(id, data) {
		return http.post(`/updateDetail/${id}`, data);
	},
	//删除主办方/嘉宾
	deleteGuest(id) {
		return http.delete(`/deleteDetail/${id}`);
	},
	//排序
	instroSort(id, params) {
		return http.post(`/updatePriority/${id}`, params);
	}
};
